
import React from "react";
import {Icon} from '@fluentui/react';
import PeoplePicker from "../formFields/PeoplePicker";

class Person extends React.Component
{
    _onSelectedUser(user) {
        this.props.onChange(user);
    }

    isUserValid(users) {
        return users && users.length > 0 && !users[0].isDeleted;
    }


    render() {
        const users = Array.isArray(this.props.user) ? this.props.user : [this.props.user];
        const warningText = users.length > 0 ? 'User account is not active' : '';
        
        const warningIcon = <div className='warning-inline warning-nolabel-peoplepicker'><Icon title={warningText} iconName="Warning"/></div>;
        const warning = this.props.isRequired && !this.isUserValid(users) && warningIcon;

        return(
            <div style={{marginBottom: '10px', position: 'relative'}}>
                <div className="item-title">{this.props.userType}</div>
                {warning}
                <PeoplePicker
                    disabled={this.props.disabled || this.props.isreadonly}
                    key ="person"
                    defaultUsers={users}
                    onSelectedUsers={this._onSelectedUser.bind(this)}
                    itemLimit={this.props.limited ? 1 : undefined}
                />
            </div>
        );
    }
}
export default Person



// WEBPACK FOOTER //
// ./src/components/EditSite/Person.js